import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { BsBoxFill, BsPencilSquare, BsInboxFill, BsTrashFill, BsPlusSquareFill, BsKeyFill, BsCheckCircleFill, BsDashCircleFill } from "react-icons/bs";

export default function SearchableList({ header, list,
    optionLabel = "name", onClick,
    buttons, headerButtons = [], onSearch, onRowRender,
    listStyle = { maxHeight: '350px' } }) {
    const [selectedValue, setSelectedValue] = React.useState()
    const [filter, setFilter] = React.useState(list)
    React.useEffect(() => { setFilter(list) }, [list])
    const [selectedIndex, setSelectedIndex] = React.useState(1);
    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };

    const itemTemplate = (option) => {
        if (onRowRender) return onRowRender(option, buttons?.map((btn, idx) => <span onClick={() => { onClick(idx, option) }}>{btn}</span>))
        return (
            <div className="d-flex gap-1 align-items-center flex-wrapper w-100">
                <div><BsBoxFill fontSize={20} /></div>
                <div className="flex-grow-1">{option[optionLabel]}</div>
                <div className="d-flex gap-2 align-items-center">
                    {buttons?.map((btn, idx) => <span onClick={() => { onClick(idx, option) }}>{btn}</span>)}
                </div>
            </div>
        );
    };
    const filterTemplate = (option) => {
        return (<>
            <Box display={'flex'} gap={1} alignItems={'center'}>
                <input placeholder="Search" onChange={(e) => { search(e) }} />
                {headerButtons.map((btn) => btn)}
                {!headerButtons && <BsPlusSquareFill fontSize={24} color="green" className="cursor-pointer" onClick={() => { if (onClick) onClick("add") }} />}
            </Box>
            {header}
        </>
        );
    };
    const search = (event) => {
        // Timeout to emulate a network connection
        console.log("event", event.target.value.length)
        setTimeout(() => {
            if (onSearch) {
                onSearch(event.target.value)
            } else {
                let _filtered;
                if (event.target.value.trim().length == 0) {
                    _filtered = [...list];
                } else {
                    _filtered = list.filter((obj) => {
                        return obj[optionLabel].toLowerCase().startsWith(event.target.value.toLowerCase());
                    });
                }
                setFilter(_filtered);
            }
        }, 250);
    }
    return (
        <>
            <Box sx={{ width: '100%' }}>
                {filterTemplate()}
                <List component="nav" aria-label="main mailbox folders">
                    {list?.map((o) => <ListItemButton
                        selected={selectedIndex === 0}
                        onClick={(event) => handleListItemClick(event, 0)}
                    >
                        {onRowRender ? onRowRender(o) : <>
                            <ListItemText primary={o[optionLabel ? optionLabel : "text"]} />
                            <ListItemIcon>
                                <Box display={'flex'} gap="2">
                                    {buttons?.map((btn, idx) => <span  onClick={() => { onClick(idx, o) }}>{btn}</span>)}
                                </Box>
                            </ListItemIcon>
                        </>}

                    </ListItemButton>)}

                </List>
            </Box>

        </>
    )
}